const userIpMutation = (email, ip, skin) => `mutation {
    createUserIp(data: { email: "${email}", ip: "${ip}", brand: "${skin}" }) {
        data {
            id
        }
    }
}`;

export { userIpMutation };
